import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=bc4e38da&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=bc4e38da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4e38da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc4e38da')) {
      api.createRecord('bc4e38da', component.options)
    } else {
      api.reload('bc4e38da', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=bc4e38da&scoped=true&", function () {
      api.rerender('bc4e38da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RmR2VfPmcnHT/JS/comp/PopupBox.vue"
export default component.exports